import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Calendar, Target, HeartPulse, ChevronDown } from 'lucide-react';
export function Bonuses() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const bonuses = [{
    title: 'SISTEMA "ANTI ESTANCAMIENTO"',
    subtitle: 'Plan completo de progresión de 12 semanas',
    pages: '30 páginas',
    icon: <Calendar className="w-8 h-8 text-orange-500" data-id="element-10" />,
    items: ['planificación semanal', 'progresión de grados', 'control de fatiga', 'días de descarga', 'registro de agarres', 'tests de rendimiento', 'seguimiento técnico']
  }, {
    title: '150 DRILLS TÉCNICOS DE ESCALADA',
    subtitle: '"Qué hacer exactamente cuando entrenás"',
    pages: '30 páginas',
    icon: <Target className="w-8 h-8 text-orange-500" data-id="element-11" />,
    items: ['drills de pies', 'drills de equilibrio', 'drills de lectura', 'drills de coordinación', 'drills de potencia', 'drills de resistencia', 'drills para boulder', 'drills para deportiva']
  }, {
    title: 'MANUAL DE RECUPERACIÓN DEL ESCALADOR',
    subtitle: '"Cómo recuperarte más rápido y evitar destruirte"',
    pages: '20–30 páginas',
    icon: <HeartPulse className="w-8 h-8 text-orange-500" data-id="element-12" />,
    items: ['recuperación de dedos', 'recuperación de antebrazos', 'movilidad específica', 'sueño y rendimiento', 'protocolos post sesión', 'recuperación neural', 'manejo de fatiga', 'señales de sobreentrenamiento']
  }];
  return <section className="py-16 md:py-24 px-4 bg-darker border-t border-gray-900" data-id="element-13">
      <div className="max-w-4xl mx-auto" data-id="element-14">
        <div className="text-center mb-12" data-id="element-15">
          <h2 className="text-4xl md:text-5xl font-bebas mb-4" data-id="element-16">
            🎁 BONOS GRATIS{' '}
            <span className="text-orange-500" data-id="element-17">SOLO POR HOY</span>
          </h2>
          <p className="text-xl text-gray-300 font-medium" data-id="element-18">
            Si comprás hoy, te llevás estos 3 bonos sin costo adicional.
          </p>
        </div>

        <div className="space-y-4" data-id="element-19">
          {bonuses.map((bono, idx) => {
          const isOpen = openIndex === idx;
          return <div key={idx} className={`bg-card rounded-xl border transition-colors duration-300 overflow-hidden ${isOpen ? 'border-orange-500' : 'border-gray-800'}`} data-id="element-20">
                <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full text-left px-6 py-5 flex justify-between items-center focus:outline-none gap-4" data-id="element-21">
                  <div className="flex items-center gap-4 flex-1 min-w-0" data-id="element-22">
                    <div className="bg-orange-500/10 p-3 rounded-lg flex-shrink-0" data-id="element-23">
                      {bono.icon}
                    </div>
                    <div className="min-w-0" data-id="element-24">
                      <div className="text-orange-500 font-bold text-xs mb-1 tracking-widest uppercase" data-id="element-25">
                        BONO {idx + 1} · GRATIS HOY
                      </div>
                      <h3 className="text-lg md:text-xl font-bebas tracking-wide text-white leading-tight" data-id="element-26">
                        {bono.title}
                      </h3>
                    </div>
                  </div>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className="flex-shrink-0" data-id="element-27">
                    <ChevronDown className={`w-6 h-6 ${isOpen ? 'text-orange-500' : 'text-gray-400'}`} data-id="element-28" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-29">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-30">
                      <div className="px-6 pb-6 pt-2 border-t border-gray-800/50" data-id="element-31">
                        <p className="text-gray-400 italic text-sm mb-1 mt-4" data-id="element-32">
                          {bono.subtitle}
                        </p>
                        <p className="text-gray-500 text-xs mb-5" data-id="element-33">
                          {bono.pages}
                        </p>

                        <p className="font-semibold text-sm text-white mb-3" data-id="element-34">
                          Incluye:
                        </p>
                        <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2" data-id="element-35">
                          {bono.items.map((item, iIdx) => <li key={iIdx} className="flex items-start text-sm text-gray-300" data-id="element-36">
                              <span className="text-orange-500 mr-2 mt-0.5" data-id="element-37">
                                ✓
                              </span>
                              {item}
                            </li>)}
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}